import { css } from 'styled-components';

const flexAsRow = (gapSize = null) => ({ theme }) => {
  const gap = gapSize ? `gap: ${theme.spacing(gapSize)};` : '';

  return css`
    display: flex;
    flex-direction: row;
    ${gap}
  `;
};

export default flexAsRow;
